import styled from 'styled-components';
import Card from '$app/components/vendor/Card';

const colors = {
  'clear-blue': '#2b9bff',
  'cloudy-blue': '#bbc3d3',
  'title-black': '#201e1e'
}

export const EditButton = styled.button`
  padding: 2px 4px 0px 7px;
  min-width: 10px;
  min-height: 10px;
  color: ${colors['clear-blue']};
  border: none;
  background: none;
  &:focus {
    outline: 0;
    box-shadow: none;
  }
`

export const DetailsCard = styled(Card)`
  margin-bottom: 0;
  .garage-address {
    margin-top: 15px;
    margin-bottom: 5px;
    font-weight: 700;
    color: ${colors['title-black']};
  }
`

export const DateTimeSpan = styled.span`
  color: ${colors['title-black']};
  b {
    margin-right: 15px;
  }
`

export const Address = styled.div`
  margin-top: 5px;
  color: ${colors['title-black']};
`;